export const WORK_PROGRAMS_GROUP_NAME = {
  REQUIRED: "Рабочие программы по учебным предметам, входящим в обязательную часть учебного плана",
  ADDITIONAL: "Рабочие программы по учебным предметам, входящим в часть учебного плана, формируемую участниками образовательных отношений",
  EXTRACURRICULAR: "Рабочие программы внеурочной деятельности",
};